import { useMemo } from 'react';
import { Box, Switch } from '@chakra-ui/react';
import { Button, Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { FLAGS, FeatureFlagKey } from 'utils/featureFlags';

const containerStyle = {
  width: '100%',
  maxWidth: '600px',
  padding: 'padding_24',
};

const sectionStyle = {
  my: 'padding_24',
  padding: 'padding_16',
  border: '1px solid',
  borderColor: Colors.ArmyGreen300,
  borderRadius: '8px',
  gap: 'padding_16',
};

const flagHeaderStyle = {
  justifyContent: 'space-between',
  alignItems: 'center',
};

const resetButtonStyle = {
  mt: 'padding_16',
};

const FeatureFlags = () => {
  const { flags, toggleFlag, resetFlags, isFlagEnabled } = useFeatureFlags();

  const flagEntries = useMemo(() => {
    return Object.entries(FLAGS) as [FeatureFlagKey, string][];
  }, []);

  const hasAnyEnabled = useMemo(() => {
    return Object.values(flags).some((enabled) => enabled);
  }, [flags]);

  return (
    <Box sx={containerStyle}>
      <Text.Lead color={Colors.SystemColorNegative}>** INTERNAL USE ONLY **</Text.Lead>
      <Text>
        Feature flags are intended for internal testing and experimentation. <br />
        Toggling feature flags on/off will give you access to experimental features.
      </Text>

      <FlexColumn sx={sectionStyle}>
        {flagEntries.map(([flagKey]) => {
          const isEnabled = isFlagEnabled(flagKey);

          return (
            <FlexRow sx={flagHeaderStyle} key={flagKey}>
              <Text.LargeBold>{flagKey.replace(/_/g, ' ').toUpperCase()}</Text.LargeBold>
              <Switch
                colorScheme="green"
                isChecked={isEnabled}
                onChange={() => toggleFlag(flagKey)}
                size="lg"
              />
            </FlexRow>
          );
        })}
      </FlexColumn>

      <FlexRow sx={resetButtonStyle}>
        <Button color="secondary" onClick={resetFlags} disabled={!hasAnyEnabled}>
          Reset all flags
        </Button>
      </FlexRow>
    </Box>
  );
};

export default FeatureFlags;
